import { createFileRoute } from '@tanstack/react-router'
import { SMS } from '@/components/settings-route/multi-channel/sms/index.jsx'

export const Route = createFileRoute('/_auth/settings/multi-channels/sms')({
  component: SMS,
})
